/* AlphaX business hours + ticket clocks. GENERATED from ultra-ticketing-system/backend/{BizHours,Clocks}.gs
   by dev/build-assets.js — do not edit here. */
/**
 * BizHours.gs — business-hours engine (plan §3).
 *
 * Shared source: this exact file is also published to the theme as
 * assets/ax-bizhours.js, so the server and the screen always agree.
 * Pure JS, no Apps Script services.
 *
 * All inputs/outputs are UTC epoch ms (Date objects and ISO strings are accepted
 * as inputs). Internally times are shifted to Puerto Rico local time (UTC−4,
 * no DST) and handled with the Date UTC getters.
 *
 *   const bh = BizHours.create(holidayRows);   // rows: [{name, rule, closed}]
 *   bh.isOpen(t) · bh.addBusinessHours(start, h) · bh.businessMsBetween(a, b)
 *   bh.remaining(deadline, now) · BizHours.format(ms)
 */
var BizHours = (function () {
  var HOUR = 3600 * 1000;
  var DAY = 24 * HOUR;
  var PR_OFFSET = -4 * HOUR;
  // getUTCDay() → [open hour, close hour] or null (closed)
  var SCHEDULE = { 0: null, 1: [12, 20], 2: [12, 20], 3: [12, 20], 4: [12, 20], 5: [12, 20], 6: [10, 14] };
  var DOW = { SUN: 0, MON: 1, TUE: 2, WED: 3, THU: 4, FRI: 5, SAT: 6 };

  function toMs(t) {
    if (t instanceof Date) return t.getTime();
    if (typeof t === 'number') return t;
    var ms = new Date(t).getTime();
    if (isNaN(ms)) throw new Error('BizHours: invalid time ' + t);
    return ms;
  }

  function pad(n) { return (n < 10 ? '0' : '') + n; }

  function ymd(y, m, d) { return y + '-' + pad(m) + '-' + pad(d); }

  /** Easter Sunday (Gregorian, anonymous algorithm) → [month, day]. */
  function easter(y) {
    var a = y % 19, b = Math.floor(y / 100), c = y % 100, d = Math.floor(b / 4), e = b % 4;
    var f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    var h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    var l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    var month = Math.floor((h + l - 7 * m + 114) / 31);
    var day = ((h + l - 7 * m + 114) % 31) + 1;
    return [month, day];
  }

  /** Date string 'YYYY-MM-DD' for one holiday rule in year y, or null if it doesn't apply. */
  function ruleDate(rule, y) {
    var p = String(rule).trim().split(':');
    var kind = p[0].toLowerCase();
    var dt;
    if (kind === 'fixed') {
      var md = p[1].split('-');
      return ymd(y, Number(md[0]), Number(md[1]));
    }
    if (kind === 'date') {
      return p[1].indexOf(String(y)) === 0 ? p[1] : null;
    }
    if (kind === 'nth') {
      var month = Number(p[1]), dow = DOW[p[2].toUpperCase()], n = Number(p[3]);
      var first = new Date(Date.UTC(y, month - 1, 1)).getUTCDay();
      return ymd(y, month, 1 + ((dow - first + 7) % 7) + (n - 1) * 7);
    }
    if (kind === 'last') {
      var lm = Number(p[1]), ldow = DOW[p[2].toUpperCase()];
      var lastDay = new Date(Date.UTC(y, lm, 0));
      var back = (lastDay.getUTCDay() - ldow + 7) % 7;
      return ymd(y, lm, lastDay.getUTCDate() - back);
    }
    if (kind === 'easter') {
      var em = easter(y);
      dt = new Date(Date.UTC(y, em[0] - 1, em[1] + Number(p[1] || 0)));
      return ymd(dt.getUTCFullYear(), dt.getUTCMonth() + 1, dt.getUTCDate());
    }
    throw new Error('BizHours: unknown holiday rule ' + rule);
  }

  function isClosedFlag(v) {
    return v === true || String(v).trim().toUpperCase() === 'TRUE';
  }

  function create(holidayRows) {
    var rules = (holidayRows || []).filter(function (h) { return isClosedFlag(h.closed); }).map(function (h) { return h.rule; });
    var years = {};
    var closed = {};

    function ensureYear(y) {
      if (years[y]) return;
      years[y] = true;
      rules.forEach(function (r) {
        var d = ruleDate(r, y);
        if (d) closed[d] = true;
      });
    }

    /** Open window of the PR-local day starting at localDayMs → [openLocalMs, closeLocalMs] or null. */
    function windowFor(localDayMs) {
      var d = new Date(localDayMs);
      var y = d.getUTCFullYear();
      ensureYear(y);
      if (closed[ymd(y, d.getUTCMonth() + 1, d.getUTCDate())]) return null;
      var s = SCHEDULE[d.getUTCDay()];
      return s ? [localDayMs + s[0] * HOUR, localDayMs + s[1] * HOUR] : null;
    }

    function dayStart(localMs) { return Math.floor(localMs / DAY) * DAY; }

    function isOpen(t) {
      var local = toMs(t) + PR_OFFSET;
      var w = windowFor(dayStart(local));
      return !!w && local >= w[0] && local < w[1];
    }

    function addBusinessHours(start, hours) {
      var t = toMs(start) + PR_OFFSET;
      var left = Math.round(hours * HOUR);
      for (var guard = 0; guard < 3660; guard++) {
        var day = dayStart(t);
        var w = windowFor(day);
        if (w && t < w[1]) {
          if (t < w[0]) t = w[0];
          var avail = w[1] - t;
          if (left <= avail) return t + left - PR_OFFSET;
          left -= avail;
        }
        t = day + DAY;
      }
      throw new Error('BizHours: addBusinessHours ran past 10 years');
    }

    function businessMsBetween(a, b) {
      var from = toMs(a), to = toMs(b);
      if (to < from) return -businessMsBetween(to, from);
      var lo = from + PR_OFFSET, hi = to + PR_OFFSET, total = 0;
      for (var day = dayStart(lo); day < hi; day += DAY) {
        var w = windowFor(day);
        if (w) total += Math.max(0, Math.min(hi, w[1]) - Math.max(lo, w[0]));
      }
      return total;
    }

    function remaining(deadline, now) {
      return businessMsBetween(now, deadline);
    }

    /** All closed dates ('YYYY-MM-DD') for a year — for display and tests. */
    function holidaysIn(y) {
      ensureYear(y);
      return Object.keys(closed).filter(function (d) { return d.indexOf(y + '-') === 0; }).sort();
    }

    return {
      isOpen: isOpen,
      addBusinessHours: addBusinessHours,
      businessMsBetween: businessMsBetween,
      remaining: remaining,
      holidaysIn: holidaysIn,
    };
  }

  /** ms → "HHh MMm"; negative → "−HHh MMm". */
  function format(ms) {
    var neg = ms < 0;
    var mins = Math.floor(Math.abs(ms) / 60000);
    return (neg ? '−' : '') + pad(Math.floor(mins / 60)) + 'h ' + pad(mins % 60) + 'm';
  }

  return { create: create, format: format, ruleDate: ruleDate, HOUR: HOUR };
})();

if (typeof module !== 'undefined' && module.exports) module.exports = BizHours;

/**
 * Clocks.gs — ticket clocks (plan §3.4), computed from the ticket row, never stored.
 *
 * Shared source like BizHours.gs: also published to the theme (Phase 2) so the
 * board shows exactly what the server enforces. Pure JS, no Apps Script services.
 *
 *   TicketClocks.compute(ticket, now, bh) → [{name, owner, startAt, deadline, remainingMs, overdue, warn}]
 *   owner: 'cs' | 'ts' | 'customer'. Times are epoch ms.
 */
var TicketClocks = (function () {
  var HOUR = 3600 * 1000;
  var WARN_MS = 6 * HOUR;
  var LENGTH_H = { response: 24, customerReply: 40, diagPay: 40, repairPay: 40, diagnosis: 120, repair: 120, refund: 40, postDelivery: 40, filesDue: 48 };
  var CS_STATES = ['CS_INTAKE', 'CS_ACTIVE'];
  // Customer may mark Resolved only here (hidden while we have the unit, plan §4.3).
  var RESOLVE_STATES = ['CS_INTAKE', 'CS_ACTIVE', 'TS_INTAKE', 'RMA_AWAIT_DIAG_PAY', 'RMA_RETURNED'];

  function ms(v) {
    if (!v) return 0;
    var t = new Date(v).getTime();
    return isNaN(t) ? 0 : t;
  }

  function truthy(v) {
    return v === true || String(v).toUpperCase() === 'TRUE';
  }

  /** Portal holding the ticket: 'cs', 'ts' or null (archived). */
  function holderOf(state) {
    if (!state || state === 'ARCHIVED') return null;
    return CS_STATES.indexOf(state) >= 0 ? 'cs' : 'ts';
  }

  function compute(t, now, bh) {
    var nowMs = ms(now) || Date.now();
    var out = [];
    function add(name, owner, startMs) {
      if (!startMs) return;
      var deadline = bh.addBusinessHours(startMs, LENGTH_H[name]);
      var rem = bh.remaining(deadline, nowMs);
      out.push({ name: name, owner: owner, startAt: startMs, deadline: deadline, remainingMs: rem, overdue: rem < 0, warn: rem >= 0 && rem <= WARN_MS });
    }
    var state = t.state;
    var holder = holderOf(state);

    if (holder && t.firstUnansweredAt) add('response', holder, ms(t.firstUnansweredAt));
    if (state === 'CS_ACTIVE' && t.lastStaffPublicAt && ms(t.lastStaffPublicAt) > ms(t.lastCustomerAt)) {
      add('customerReply', 'customer', ms(t.lastStaffPublicAt));
    }
    if (holder && t.filesRequestedAt) add('filesDue', 'customer', ms(t.filesRequestedAt));   // log & tune request (Files.gs)
    if (state === 'RMA_AWAIT_DIAG_PAY') add('diagPay', 'customer', ms(t.stateSince));
    if (state === 'RMA_AWAIT_REPAIR_PAY') add('repairPay', 'customer', ms(t.stateSince));
    if (state === 'RMA_ON_HAND') add('diagnosis', 'ts', ms(t.stateSince));   // 15 business days from delivery
    if (state === 'RMA_REPAIR') add('repair', 'ts', ms(t.stateSince));
    if (truthy(t.refundPending)) add('refund', 'cs', ms(t.refundSince));
    if (state === 'RMA_RETURNED' && !t.firstUnansweredAt) {
      add('postDelivery', 'customer', Math.max(ms(t.stateSince), ms(t.lastStaffPublicAt)));
    }
    return out;
  }

  /** Most urgent clock for one owner, or null. */
  function mostUrgent(clocks, owner) {
    var best = null;
    clocks.forEach(function (c) {
      if (c.owner === owner && (!best || c.remainingMs < best.remainingMs)) best = c;
    });
    return best;
  }

  function find(clocks, name) {
    for (var i = 0; i < clocks.length; i++) if (clocks[i].name === name) return clocks[i];
    return null;
  }

  /** Red "unseen" (A4): in this portal's Intake and nobody in the portal opened it since it arrived. */
  function isUnseen(t, portal) {
    var intake = portal === 'cs' ? 'CS_INTAKE' : 'TS_INTAKE';
    var seen = portal === 'cs' ? t.seenCsAt : t.seenTsAt;
    return t.state === intake && (!seen || ms(seen) < ms(t.stateSince));
  }

  function canResolve(state) {
    return RESOLVE_STATES.indexOf(state) >= 0;
  }

  return {
    compute: compute, mostUrgent: mostUrgent, find: find, holderOf: holderOf,
    isUnseen: isUnseen, canResolve: canResolve, LENGTH_H: LENGTH_H, WARN_MS: WARN_MS,
  };
})();

if (typeof module !== 'undefined' && module.exports) module.exports = TicketClocks;
